import { render, staticRenderFns } from "./ComixVolumeSlider.vue?vue&type=template&id=7edc31cf&scoped=true&"
import script from "./ComixVolumeSlider.vue?vue&type=script&lang=js&"
export * from "./ComixVolumeSlider.vue?vue&type=script&lang=js&"
import style0 from "./ComixVolumeSlider.vue?vue&type=style&index=0&id=7edc31cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edc31cf",
  null
  
)

export default component.exports